import { render, staticRenderFns } from "./JMenu.vue?vue&type=template&id=1249cae6&scoped=true"
import script from "./JMenu.vue?vue&type=script&lang=js"
export * from "./JMenu.vue?vue&type=script&lang=js"
import style0 from "./JMenu.vue?vue&type=style&index=0&id=1249cae6&prod&scoped=true&lang=scss"
import style1 from "./JMenu.vue?vue&type=style&index=1&id=1249cae6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1249cae6",
  null
  
)

export default component.exports